<template>
	<div>
		<performance-review-template-editor v-if="template != null" :template="template" :is-admin="loggedInEmployee.isAdmin" :is-saving="isSaving" title="Edit Template" @save="onSave" @cancel="onCancel" />
	</div>
</template>

<script>
	import PerformanceReviewTemplateEditor from '@/components/performanceReview/PerformanceReviewTemplateEditor';
	import { mapGetters } from 'vuex';

	export default {
		props: {
			id: {
				required: true
			}
		},
		data() {
			return {
				savedNotif: false,
				isSaving: false
			};
		},
		components: {
			PerformanceReviewTemplateEditor
		},
		created() {
			this.$store.dispatch('setPageTitle', 'Edit Template');
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee'
			}),
			template() {
				return this.$store.state.performanceReviewTemplates.templates.find(template => template.id == this.id);
			}
		},
		methods: {
			onSave(template) {
				this.isSaving = true;
				this.$store.dispatch('performanceReviewTemplates/edit', template).then(
					response => {
						this.isSaving = false;
						// this.savedNotif = true;
						this.$router.push(`/prTemplate/${template.id}/`);
					},
					error => {
						this.isSaving = false;
						console.error('Error saving Performance Review Template');
					}
				);
			},
			onCancel() {
				window.history.back();
			}
		}
	};
</script>

<style></style>
